import { IWithStatsWidgetProps, withStatsWidget } from "@Hocs/with.stats_widget";
import React from "react";

export const _WidgetTypeIframe = ({
  data: _data,
  stats_widget,
  t: _t,
}: IWithStatsWidgetProps) => {
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <iframe
        sandbox="allow-forms allow-scripts allow-same-origin"
        referrerPolicy="no-referrer"
        style={{ width: "inherit", height: "inherit" }}
        src={stats_widget.settings.source}
      ></iframe>
    </div>
  );
};

export const WidgetTypeIFrame = React.memo(withStatsWidget(_WidgetTypeIframe));
